export default "__VITE_ASSET__BKFtOTlA__"